/**
 * @param arrayNumber number型 例) 123 か string型 例) "123" の配列 [1,4,6,"123"]
 * @returns 上記の配列の中身を全て合算したnumber
 */
export const sum = (arrayNumber: (number | null | undefined)[]): number => {
  return (
    arrayNumber
      .filter((item) => item !== null && item !== undefined)
      .reduce((acc, currentValue) => (acc ?? 0) + (currentValue ?? 0), 0) ?? 0
  );
};

/**
 *
 * @param total 全件数
 * @param limit ページに表示する件数 デフォルト: 20
 * @returns ページ数
 */
export const calcTotalPage = (total: number, limit = 20): number => {
  return Math.ceil(total / limit);
};
